export const USER_MESSAGE = {
    QUESTION: 'user/question',
    RECORDING: 'user/recording',
}

export const ASSISTANT_MESSAGE = {
    ANSWER: 'assistant/answer',
    ERROR: 'assistant/error',
    LOADING: 'assistant/loading',
}